module.exports = __webpack_public_path__ + "static/img/AccountSupport_img2.9864331c.png";